import SigliveServiceV3 from 'Service/sigliveServiceV3';

const postTarget = async ({ payload }) => {
  const { data } = await SigliveServiceV3({ method: 'POST', url: `/target`, data: payload });

  return data;
};

export default postTarget;
